// Dream Recovery: wählt beim ersten Laden das Standard-Paket (z. B. „3 Monate“),
// solange die Adresse keine ?variant= enthält. Löst Dawns normale Variantenlogik aus.
(() => {
  if (new URLSearchParams(window.location.search).has('variant')) return;
  const run = () => {
    document.querySelectorAll('fieldset.dr-plans[data-dr-default]').forEach((fs) => {
      if (fs.dataset.drDefaultDone) return;
      fs.dataset.drDefaultDone = '1';
      const wanted = fs.dataset.drDefault.trim().toLowerCase();
      const input = Array.from(fs.querySelectorAll('input[type="radio"]')).find(
        (i) => i.value.trim().toLowerCase() === wanted
      );
      if (input && !input.checked && !input.classList.contains('disabled')) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };
  if (customElements.get('variant-selects')) run();
  else customElements.whenDefined('variant-selects').then(run);
})();
